export function RequiredMark() {
  return (
    <span className="erp-required" aria-hidden="true">
      *
    </span>
  );
}
